import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import './Dashboard.css';

const Dashboard = () => {
    const [user, setUser] = useState(null);
    const [companyStats, setCompanyStats] = useState({});
    const [typeStats, setTypeStats] = useState({});
    const [companyTypeStats, setCompanyTypeStats] = useState({});

    useEffect(() => {
        // Check for user in local storage
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
            setUser(storedUser);
            if (storedUser.isAdmin) {
                fetchAllTickets();
            }
        }
    }, []);

    const fetchAllTickets = async () => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}/Tickets`);
            const tickets = response.data;
            
            const companyStats = {};
            const typeStats = {};
            const companyTypeStats = {};

            tickets.forEach(ticket => {
                const company = ticket.company || 'Unknown Company';
                const status = ticket.status || 'Unknown Status';
                const type = ticket.type || 'Unknown Type';

                // Company statistics
                if (!companyStats[company]) {
                    companyStats[company] = { total: 0, statuses: {} };
                }
                if (!companyStats[company].statuses[status]) {
                    companyStats[company].statuses[status] = 0;
                }
                companyStats[company].statuses[status]++;
                companyStats[company].total++;

                // Type statistics
                if (!typeStats[type]) {
                    typeStats[type] = { total: 0, statuses: {} };
                }
                if (!typeStats[type].statuses[status]) {
                    typeStats[type].statuses[status] = 0;
                }
                typeStats[type].statuses[status]++;
                typeStats[type].total++;

                // Company Type statistics
                if (!companyTypeStats[company]) {
                    companyTypeStats[company] = {};
                }
                if (!companyTypeStats[company][type]) {
                    companyTypeStats[company][type] = { total: 0, statuses: {} };
                }
                if (!companyTypeStats[company][type].statuses[status]) {
                    companyTypeStats[company][type].statuses[status] = 0;
                }
                companyTypeStats[company][type].statuses[status]++;
                companyTypeStats[company][type].total++;
            });

            setCompanyStats(companyStats);
            setTypeStats(typeStats);
            setCompanyTypeStats(companyTypeStats);
        } catch (error) {
            console.error('Error fetching tickets:', error);
        }
    };

    if (!user) {
        return <div>Loading... Please make sure you're logged in.</div>;
    }

    return (
        <div className="dashboard">
            {user.isAdmin && (
                <>
                    <div className="dashboard-section">
                        <h2>Company Ticket Statistics</h2>
                        <div className="card-grid">
                            {Object.entries(companyStats).map(([company, data]) => (
                                <div key={company} className="card">
                                    <h3>{company}</h3>
                                    <p className="total-tickets">Total Tickets: {data.total}</p>
                                    <div className="status-stats">
                                        {Object.entries(data.statuses).map(([status, count]) => (
                                            <div key={status} className="status-stat">
                                                <span className="status-name">{status}</span>
                                                <span className="status-count">{count}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="dashboard-section">
                        <h2>Ticket Type Statistics</h2>
                        <div className="card-grid">
                            {Object.entries(typeStats).map(([type, data]) => (
                                <div key={type} className="card">
                                    <h3>{type}</h3>
                                    <p className="total-tickets">Total Tickets: {data.total}</p>
                                    <div className="status-stats">
                                        {Object.entries(data.statuses).map(([status, count]) => (
                                            <div key={status} className="status-stat">
                                                <span className="status-name">{status}</span>
                                                <span className="status-count">{count}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="dashboard-section">
                        <h2>Ticket Type Statistics by Company</h2>
                        <div className="card-grid">
                            {Object.entries(companyTypeStats).map(([company, types]) => (
                                <div key={company} className="card">
                                    <h3>{company}</h3>
                                    {Object.entries(types).map(([type, data]) => (
                                        <div key={type} className="type-stat">
                                            <h4>{type}</h4>
                                            <p className="total-tickets">Total: {data.total}</p>
                                            <div className="status-stats">
                                                {Object.entries(data.statuses).map(([status, count]) => (
                                                    <div key={status} className="status-stat">
                                                        <span className="status-name">{status}</span>
                                                        <span className="status-count">{count}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Dashboard;
